import React, {FC, useEffect} from 'react';

import {VaultedPaymentMethod} from '@primer-io/checkout-web';

import {connect} from 'react-redux';

import {setVaultPaymentId as setVaultPaymentIdAction} from 'desktop/pages/checkout/store/reducers/primer/primer';

import {SavedCardsList} from '../../../savedCardsList/savedCardsList';
import {PrimerInstrumentTypes} from '../../constants';

type PropsType = {
    vaultedPaymentMethods: VaultedPaymentMethod[];
    setVaultPaymentId: (value: string) => void;
};

/**
 * Show previous saved(vaulted) cards for primer payment method
 */
const VaultedCards: FC<PropsType> = ({setVaultPaymentId, vaultedPaymentMethods}) => {
    const handleChangeCard = (index: number) => {
        setVaultPaymentId(vaultedPaymentMethods[index].id);
    };

    useEffect(() => {
        setVaultPaymentId(vaultedPaymentMethods[0].id);
    }, [setVaultPaymentId, vaultedPaymentMethods]);

    return (
        <SavedCardsList
            cards={vaultedPaymentMethods
                .filter(
                    method => method.paymentInstrumentType === PrimerInstrumentTypes.PAYMENT_CARD,
                )
                .map(method => ({
                    id: method.id,
                    name: `XXXX-${method.paymentInstrumentData.last4Digits}`,
                }))}
            onChange={handleChangeCard}
        />
    );
};

export const VaultedCardsConnected = connect(null, {
    setVaultPaymentId: setVaultPaymentIdAction,
})(VaultedCards);
